import { useStorage } from '@vueuse/core'

/**
 * Persistita in localStorage (mai un cookie: coerente con "niente cookie di
 * tracciamento", vedi 07-security.md § Privacy/GDPR). Una volta chiusa non
 * deve ripresentarsi a ogni caricamento.
 *
 * Edge case tollerato: su iOS/WebKit la PWA installata standalone può avere
 * uno storage partition separato dalla scheda Safari dov'era stata chiusa la
 * prima volta, quindi può ricomparire una volta dopo l'installazione.
 */
export function usePrivacyNotice () {
  const dismissed = useStorage('mojito.privacyNoticeDismissed', false)

  function dismiss () {
    dismissed.value = true
  }

  return { dismissed, dismiss }
}
